import "./confetti/confetti.js";
import "./mobile_view/list_mobileview.js"
import "./list_view/headers.js"
import "./list_view/bulk_upload.js"

$(document).ready(function () {
    if (frappe.boot.redirect_to  && window.location.href.indexOf(frappe.boot.redirect_to) === -1) {
        window.location.href = frappe.boot.redirect_to;
    }
});